// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1HRfm","productName":"Table_productName__3Q186"};